<template>
  <div class="modal" :class='{visible: visible}' @click.self="$emit('close')">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    visible: Boolean
  },
  watch: {
    data: function(a){
      if(a!=null)
        this.visible = true;
    }
  }
}
</script>

<style scoped>

.modal{
  position: fixed;
  display: flex;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000A;
  pointer-events: none;
  align-content: center;
  align-items: center;
}

.modal:not(.visible){
  animation: animation-out 0.1s linear;
  animation-fill-mode: forwards;
  display: none;
}

.visible{
  animation: animation 0.1s linear;
  animation-fill-mode: forwards;
  pointer-events: all;

}
@keyframes animation-out {
  0%{
    opacity: 1.0;
    display: flex;
  } 
  100%{
    opacity: 0.0;
    display: none;
  }
}

@keyframes animation {
  0%{
    opacity: 0.0;
    display: flex;
  } 
  100%{
    opacity: 1.0;
    display: flex;
  }
}

</style>
